module.exports = __webpack_public_path__ + "static/img/swampy.fb54c33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/testimonial/swampy.png
// module id = 98LX
// module chunks = 35